export function initCartAjax() {
  jQuery("form.woocommerce-cart-form").on(
    "click",
    'button[name="apply_coupon"]',
    function (e) {
      e.preventDefault();
      const code = jQuery("#coupon_code").val();
      jQuery
        .post(my_ajax_object.apply_coupon_url, {
          coupon_code: code,
          security: my_ajax_object.apply_coupon_nonce,
        })
        .done(function (resp) {
          jQuery(".woocommerce-notices-wrapper").html(resp.data.notifications);
          jQuery(".cart-totals-wrapper").html(resp.data.totals);
        });
    }
  );

  function updateCart(data) {
    data.security = my_ajax_object.update_cart_nonce;
    jQuery
      .post(my_ajax_object.update_cart_url, data)
      .done(function (res) {
        if (!res.success) return console.error("Erro no AJAX do carrinho.");
        jQuery(".cart-items-col").html(res.data.cart_items);
        jQuery(".cart-totals-wrapper").html(res.data.cart_totals);
      })
      .fail(function () {
        console.error("Falha na requisição AJAX do carrinho.");
      });
  }

  jQuery(document).on("click", ".qty-decrease-cart", function (e) {
    e.preventDefault();
    const key = jQuery(this).data("cart_item_key");
    const input = jQuery(this).closest(".cart-item-quantity").find("input.qty");
    let qty = parseInt(input.val(), 10) - 1;
    if (qty < 0) qty = 0;
    updateCart({ cart_item_key: key, quantity: qty });
  });

  jQuery(document).on("click", ".qty-increase-cart", function (e) {
    e.preventDefault();
    const key = jQuery(this).data("cart_item_key");
    const input = jQuery(this).closest(".cart-item-quantity").find("input.qty");
    let qty = parseInt(input.val(), 10) + 1;
    updateCart({ cart_item_key: key, quantity: qty });
  });
  jQuery(document).on("click", ".cart-item-remove a.remove", function (e) {
    e.preventDefault();
    const key = jQuery(this).data("cart_item_key");
    updateCart({ cart_item_key: key, remove_item: true });
  });

  jQuery(document).on("click", ".cross-add .add-to-cart-btn", function (e) {
    e.preventDefault();
    var btn = jQuery(this),
      pid = btn.data("product_id"),
      qty =
        parseInt(
          btn.closest(".cross-sell-item").find("input.quantity-input").val(),
          10
        ) || 1;
    updateCart({
      add_product_id: pid,
      quantity: qty,
    });
  });
  jQuery(document).on(
    "click",
    ".shipping-calculator-form button",
    function (e) {
      e.preventDefault();
      var postcode = jQuery("#calc_shipping_postcode").val() || "";
      jQuery
        .post(my_ajax_object.calc_shipping_url, {
          calc_shipping_postcode: postcode,
          security: my_ajax_object.calc_shipping_nonce,
        })
        .done(function (resp) {
          // exibe aviso (se houver)
          if (resp.data.notifications) {
            jQuery(".woocommerce-notices-wrapper").html(
              resp.data.notifications
            );
          }
          // exibe métodos somente se existir HTML
          jQuery(".shipping-methods").html(resp.data.shipping_methods);
        })
        .fail(function () {
          console.error("Erro ao calcular frete via AJAX.");
        });
    }
  );
}
